import { ShieldCheck } from "lucide-react";
import "./SecretEntrance.css";

interface SecretEntranceProps {
	onClick: () => void;
}

export const SecretEntrance = ({ onClick }: SecretEntranceProps) => {
	return (
		<button
			type="button"
			className="secret-entrance"
			onClick={(e) => {
				e.stopPropagation();
				onClick();
			}}
			aria-label="Owner Access"
			title="Owner Access"
		>
			<ShieldCheck size={20} />
		</button>
	);
};
